import apiService from './api';

const analyticsService = {
  // -------------------------------------------------------------------------
  // Public tracking (fire-and-forget, no auth)
  // -------------------------------------------------------------------------
  trackPageView: (data) =>
    apiService.post('/api/analytics/track/pageview', data, { includeAuth: false }).catch(() => {}),

  trackFunnelEvent: (data) =>
    apiService.post('/api/analytics/track/funnel', data, { includeAuth: false }).catch(() => {}),

  saveDraft: (data) =>
    apiService.post('/api/analytics/track/draft', data, { includeAuth: false }).catch(() => {}),

  // -------------------------------------------------------------------------
  // Admin dashboard reads (auth required)
  // -------------------------------------------------------------------------
  getOverview: () => apiService.get('/api/analytics/overview'),

  getActiveVisitors: () => apiService.get('/api/analytics/active-visitors'),

  getVisitors: (params = {}) => {
    const qs = new URLSearchParams(
      Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== ''))
    ).toString();
    return apiService.get(`/api/analytics/visitors${qs ? `?${qs}` : ''}`);
  },

  getVisitorTrends: (period = '7d') =>
    apiService.get(`/api/analytics/visitors/trends?period=${period}`),

  getLeads: (period = '30d') => apiService.get(`/api/analytics/leads?period=${period}`),

  getQuoteFunnel: (period = '30d') =>
    apiService.get(`/api/analytics/quote-funnel?period=${period}`),

  getFormDrafts: (params = {}) => {
    const qs = new URLSearchParams(
      Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== ''))
    ).toString();
    return apiService.get(`/api/analytics/form-drafts${qs ? `?${qs}` : ''}`);
  },
};

export default analyticsService;
